import moment from 'moment';
import { TableColumnsType } from 'pages/Dashboard/components/Table';
import { Dropdown, Menu, Space } from 'components-antd';
import Icon from 'pages/Workshop/Transactions/TransactionTasks/Icons';
import styles from './styles.module.scss';

export type BillingHistory = {
  Id?: number;
  Amount: string | number;
  Date: string;
  Last4: string;
  Reason: string;
  IsManualBilling?: boolean;
};

export const columns = (
  onEdit?: (record: BillingHistory) => void,
  onDelete?: (record: BillingHistory) => void,
): TableColumnsType<BillingHistory> => [
  {
    title: 'Reason',
    dataIndex: 'Reason',
    withSort: false,
  },
  {
    title: 'Amount',
    dataIndex: 'Amount',
    withSort: false,
    render: (v) => v || '---',
  },
  {
    title: 'Card',
    dataIndex: 'Last4',
    withSort: false,
    render: (v) => v || '---',
  },
  {
    title: 'Date',
    dataIndex: 'Date',
    withSort: false,
    render: (v) => (
      <div style={{ minWidth: '150px' }}>{moment(v).format('MMM DD, YYYY') || '---'}</div>
    ),
  },
  {
    title: '',
    key: 'actions',
    width: 50,
    render: (_, record) =>
      record.IsManualBilling && (
        <div id="dropdown" className={styles.dropdownWrap}>
          <Dropdown
            overlay={
              <Menu
                items={[
                  {
                    key: 'edit',
                    label: (
                      <div className={styles.dropdownItem} onClick={() => onEdit?.(record)}>
                        <Icon variant={Icon.OPTIONS_EDIT} className={styles.icon} />
                        <span>Edit</span>
                      </div>
                    ),
                  },
                  {
                    key: 'delete',
                    label: (
                      <div className={styles.dropdownItem} onClick={() => onDelete?.(record)}>
                        <Icon variant={Icon.OPTIONS_DELETE} className={styles.icon} />
                        <span>Delete</span>
                      </div>
                    ),
                  },
                ]}
              />
            }
            trigger={['click']}
            overlayClassName={styles.transactionMoreOptions}
            getPopupContainer={() => document.getElementById('dropdown')!}
            placement="bottomRight"
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <Icon variant={Icon.DOTS} className={styles.dropdownTrigger} />
              </Space>
            </a>
          </Dropdown>
        </div>
      ),
  },
];
